import { render } from "./SearchPopup.vue?vue&type=template&id=2fa54896&scoped=true"
import script from "./SearchPopup.vue?vue&type=script&lang=js"
export * from "./SearchPopup.vue?vue&type=script&lang=js"

import "./SearchPopup.vue?vue&type=style&index=0&id=2fa54896&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fa54896"]])

export default __exports__